import { render, staticRenderFns } from "./EnsaiosFormRegistrarResultados.vue?vue&type=template&id=6ee5d16f&"
import script from "./EnsaiosFormRegistrarResultados.vue?vue&type=script&lang=ts&"
export * from "./EnsaiosFormRegistrarResultados.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
